export default "__VITE_ASSET__488d5ce2__"